
import React from 'react';

const ThreoAIPricingHeader = () => {
  return (
    <section className="py-8 md:py-10 relative">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            ThreoAI <span className="text-gradient">Pricing</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-5">
            One Portal, Any LLM as your Gateway to AI Agents
          </p>
          <div className="max-w-3xl mx-auto bg-synthreo-black-light/70 p-6 rounded-lg border-l-4 border-synthreo-blue-light mb-6">
            <p className="text-base md:text-lg text-gray-200 leading-relaxed">
              Unlimited usage built for real business needs
              ThreoAI supports unlimited daily conversations across your selected models and data — no confusing token caps or throttling. For high-volume automation or programmatic use cases, scalable options are available on request.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThreoAIPricingHeader;
